// Analytics: Payments feature

import { type SubscriptionTier } from '@heidi/schema/ml-scribe';

export enum FTPConversionSource {
  SideBySide = 'SideBySide',
  UntrackedSource = 'UntrackedSource',
}

export const FTPConversionSourceURLQueryKey = 'conversionSource';

// Paywall contexts following the event tracking plan
export enum PaywallSource {
  ProActionOnFree = 'pro_action_on_free',
  TemplateVisibilityToTeam = 'template_visibility_to_team',
  AskAI = 'ask_ai',
  QuotaExceeded = 'quota_exceeded',
  AccountToPro = 'account_to_pro',
  AccountToPractice = 'account_to_practice',
  SessionHeader = 'session_header',
  Integration = 'integration',
  ExtendProTrial = 'extend_pro_trial',
  NoTeamMemberPage = 'no_team_member_page',
  Sidebar = 'sidebar',
  EvidenceSourcesList = 'evidence_sources_list',
  SessionReview = 'session_review',
  UpgradeModalSwitch = 'upgrade_modal_switch',
  TeamSettings = 'team_settings',
  TeamMFA = 'team_mfa',
  ClinicianUpgradeModal = 'clinician_upgrade_modal',
  PracticeUpgradeModal = 'practice_upgrade_modal',
  EvidenceProUpgradeModal = 'evidence_pro_upgrade_modal',
  EvidencePowerUserUpgradeModal = 'evidence_power_user_upgrade_modal',
  ClinicianMaxUpgradeModal = 'clinician_max_upgrade_modal',
}

/** Surfaces that can open the Clinician Max upgrade modal. */
export type ClinicianMaxUpgradeEntryPoint =
  | 'side_nav_credit_usage_popover'
  | 'settings_billing'
  | 'agent_credit_allowance_banner';

export type PaymentEventProps = {
  source: FTPConversionSource;
};

export type PaywallEventProps = {
  source: PaywallSource;
  target_plan: SubscriptionTier;
  days_left_on_trial?: number;
  /** True when the user is currently on the 90-day Clinician reverse trial. */
  is_90_day_trial_user?: boolean;
  /** True when the user's 90-day Clinician reverse trial has ended (post-trial state). */
  is_90_day_trial_ended?: boolean;
  /** Present only when the user belongs to a team. */
  is_admin?: boolean;
  team_is_stripe_managed?: boolean;
  /** Upstream surface that opened this paywall (e.g. side_nav_credit_usage_popover). */
  entry_point?: ClinicianMaxUpgradeEntryPoint;
  /** User's current subscription tier at paywall impression. */
  current_plan?: SubscriptionTier;
};

export type CheckoutStartedEventProps = {
  payment_period?: string;
};

/** Cancel retention funnel — routed to subscription_event via subscription_action. */
export type CancelFlowOpenedEventProps = {
  /** From billing info `new_product_tier` or legacy `tier` fallback. */
  plan_tier: string;
};

export type CancelReasonSelectedEventProps = {
  reason: string;
};

export type CancelOfferEventProps = {
  offer_type: 'discount' | 'clinician_session';
  reason: string;
};

export type CancelRetentionSubscriptionEventProps =
  | CancelFlowOpenedEventProps
  | CancelReasonSelectedEventProps
  | CancelOfferEventProps;
